import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "delivery-manifest-detail" }
const _hoisted_2 = { class: "background-grey-lighten-5 px-6 py-6 mb-4 rounded-lg" }
const _hoisted_3 = { class: "font-bold py-2 rounded-md" }
const _hoisted_4 = { class: "sm:flex items-start justify-between" }
const _hoisted_5 = { class: "detail-info" }
const _hoisted_6 = { class: "sm:flex items-center" }
const _hoisted_7 = { class: "flex batas-chip mr-3 pr-3" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "font-normal color-blue-grey-darken-1 text-base mr-1" }, "Berangkat : ", -1)
const _hoisted_9 = { class: "flex items-center mt-3 sm:mt-0" }
const _hoisted_10 = {
  class: "rounded-md background-green-lighten-5 py-1 px-3 mr-2",
  style: {"border":"1px solid #66BB6A"}
}
const _hoisted_11 = { class: "color-green-darken-1 text-sm" }
const _hoisted_12 = {
  class: "rounded-md background-grey-lighten-5 py-1 px-3",
  style: {"border":"1px solid #607D8B"}
}
const _hoisted_13 = {
  key: 0,
  class: "color-blue-grey text-sm"
}
const _hoisted_14 = {
  key: 0,
  class: "price-info sm:text-right  mt-3 sm:mt-0"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "text-base font-normal color-primary" }, "Pendapatan Anda", -1)
const _hoisted_16 = { class: "color-primary font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_DepatureManifest = _resolveComponent("DepatureManifest")
  const _component_LoadingManifest = _resolveComponent("LoadingManifest")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("p", _hoisted_3, _toDisplayString(_ctx.data.KodeJadwal), 1),
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.data.TransJadwalDetails.length > 0)
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        class: _ctx.$isDateOnTime(_ctx.data.TransJadwalDetails[0].WaktuKeberangkatan) ? 'color-green-darken-1 text-base' : 'color-red text-base'
                      }, _toDisplayString(_ctx.$strDate(_ctx.data.TransJadwalDetails[0].WaktuKeberangkatan)), 3))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode("div", _hoisted_10, [
                    _createVNode("p", _hoisted_11, "RIT " + _toDisplayString(_ctx.data.Rit), 1)
                  ]),
                  _createVNode("div", _hoisted_12, [
                    (_ctx.data.TipeBus)
                      ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.data.TipeBus.Kode), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            (_ctx.checkPermission(_ctx.PermissionEnum.ShowTotDetMan))
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode("h5", _hoisted_16, "Rp " + _toDisplayString(new Number(_ctx.data.TotalPendapatan).toLocaleString('id-ID')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_TabView, {
          class: "color-primary mb-4",
          activeIndex: _ctx.currentTab,
          "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTab = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, { header: "Manifest Keberangkatan" }),
            _createVNode(_component_TabPanel, { header: "Loading Manifest" })
          ]),
          _: 1
        }, 8, ["activeIndex"]),
        (_ctx.currentTab == 0)
          ? (_openBlock(), _createBlock(_component_DepatureManifest, {
              key: 0,
              detail: _ctx.data
            }, null, 8, ["detail"]))
          : (_ctx.currentTab == 1)
            ? (_openBlock(), _createBlock(_component_LoadingManifest, { key: 1 }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}